/**
 * O combinado entre o cartão do Perfil e a janela do OAuth do GitLab.
 *
 * O cartão abre a autorização numa janela à parte para a pessoa não sair do
 * Perfil; a página de retorno conclui o vínculo nessa janela, avisa quem a
 * abriu por `postMessage` (só para a mesma origem) e se fecha.
 */
export const TIPO_RESULTADO = 'consoleai:gitlab-vinculo'

export type ResultadoVinculo =
  | { tipo: typeof TIPO_RESULTADO; ok: true; gitlab_username: string }
  | { tipo: typeof TIPO_RESULTADO; ok: false; motivo: string }

export function ehResultado(data: unknown): data is ResultadoVinculo {
  return typeof data === 'object' && data !== null
    && (data as { tipo?: unknown }).tipo === TIPO_RESULTADO
}

/** A janela que o cartão abriu, se esta página estiver dentro dela. */
export function janelaDoCartao(): Window | null {
  try {
    const opener = window.opener as Window | null
    // Acessar `location` de outra origem lança: só vale a janela do próprio console.
    return opener && opener.location.origin === window.location.origin ? opener : null
  } catch {
    return null
  }
}
